import { render, staticRenderFns } from "./adp-accounts.vue?vue&type=template&id=764097e4"
import script from "./adp-accounts.vue?vue&type=script&lang=js"
export * from "./adp-accounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports